export const helpDeskExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'User Name',
		render: h => (h?.userId ? `${h.userId.firstName || ''} ${h.userId.lastName || ''}`.trim() : ''),
	},
	{
		label: 'User Mobile',
		render: h => h?.userId?.mobile || '',
	},
	{
		label: 'Community',
		render: h => h?.hub?.name || '',
	},
	{
		label: 'Sanstha',
		render: h => h?.sansthaId?.name || '',
	},
	{
		label: 'Description',
		render: h => h?.description || '',
	},
	{
		label: 'Status',
		render: h => (h?.status === 'Pending' ? 'Pending' : 'Resolved' || ''),
	},
	{
		label: 'Resolve Date',
		render: h => (h?.resolveDate ? new Date(h.resolveDate).toLocaleDateString('en-IN') : ''),
	},
]
